import { categoryList } from "../../../mocks/baogua";

const quickLinks = [
  { id: "rank", label: "今日热搜榜" },
  { id: "feed", label: "最新爆料流" },
  { id: "hotread", label: "热评精选" },
  { id: "submit", label: "我要投稿" },
  { id: "faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="bg-emerald-700 text-emerald-50 mt-6">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="grid w-9 h-9 rounded-xl bg-white text-emerald-700 items-center justify-center font-display text-lg">
                瓜
              </span>
              <span className="font-display text-2xl tracking-wide">爆瓜网</span>
            </a>
            <p className="mt-4 text-sm text-emerald-100/80 leading-relaxed">
              千万吃瓜群众的爆料聚集地。开放投稿、实时互动，让真实的声音被听见，让每一个大瓜都有来处与回声。
            </p>
          </div>

          <nav aria-label="快速导航">
            <h4 className="font-bold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5 text-sm text-emerald-100/80">
              {quickLinks.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="hover:text-white transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="font-bold text-white mb-4">主题专区</h4>
            <ul className="space-y-2.5 text-sm text-emerald-100/80">
              {categoryList.map((c) => (
                <li key={c.name}>
                  <a href="#feed" className="hover:text-white transition-colors">
                    {c.name}专区
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm text-emerald-100/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                contact@baogua.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                投稿审核：每日 9:00 - 22:00
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center mt-0.5"></i>
                内容异议与举报请通过邮件联系，我们会在 3 个工作日内处理。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-xs text-emerald-100/70">
          <p>© 2026 爆瓜网 保留所有权利。本网站内容来自网友投稿，仅供资讯分享与理性讨论，请勿转载用于商业用途。</p>
          <a href="#top" className="inline-flex items-center gap-1.5 rounded-lg bg-white/10 hover:bg-white/20 px-4 py-2 transition-colors whitespace-nowrap">
            <i className="ri-arrow-up-line w-4 h-4 flex items-center justify-center"></i> 返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}